import i18n from 'i18next';
import LanguageDetector, { DetectorOptions } from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANG, ENV, LANG_COOKIE_NAME } from '@/config';
import { APP_LANGUAGES } from '@/config/appConstants';

const getI18nCookieDomain = () => {
  if (ENV === 'localhost') {
    return;
  }

  return '.mdirector.com';
};

const detectionOptions: DetectorOptions = {
  order: ['cookie', 'localStorage', 'sessionStorage', 'navigator'],
  caches: ['cookie'],
  lookupCookie: LANG_COOKIE_NAME,
  cookieDomain: getI18nCookieDomain(),
  cookieOptions: { path: '/', sameSite: 'strict' },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANG,
    detection: detectionOptions,
    debug: false,
    supportedLngs: APP_LANGUAGES,
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'a'],
      useSuspense: false,
    },
  });

export default i18n;
